// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d53b1a1","239":"cb11f68a","455":"c0a398f3","488":"66343d10"}[chunkId] + ".chunk.js";
};